<template>
  <div class="hello">
    <el-popover
      placement="bottom-start"
      width="100%"
      @show="showTree"
      @hide="hideTree"
      trigger="click"
    >
      <div class="tree-box">
        <el-tree
          :data="treeData"
          @check="getNode"
          show-checkbox
          node-key="id"
          ref="tree"
          :check-strictly="checkStrictly"
          :props="defaultProps"
          :render-content="renderContent"
        >
        </el-tree>
      </div>
        <el-input
          slot="reference"
          v-model="inputVal"
          clearable
          @clear="clearInput"
          @focus.stop="focusEvent"
          ref="ipt"
          placeholder="请选择"
          :suffix-icon="show ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          size="small"
        ></el-input>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "POHOriginTree",
  props: {
    msg: {
      type: String,
      default: "",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 是否子父关联 false: 关联  true: 不关联
    checkStrictly: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      show: true,
      inputArr: [],
      inputVal: "",
      queryVal: "", // 用于查询的参数
      defaultProps: {
        children: "children",
        label: (data) => {
          return data.role + " " + (data.name_en ? data.name_en : "");
        },
        disabled: (data) => {
          return !data.enable;
        },
      },
      treeData: [],
    };
  },
  created() {
    this.treeData = this.data;
  },
  methods: {
    showTree() {
      this.show = true;
    },
    hideTree() {
      this.show = false;
    },
    updateData(orgTree){
      this.treeData = orgTree;
    },
    // 设置input内容
    setinputVal() {
      let str = [];
      let queryVal = [];
      for (let i = 0; i < this.inputArr.length; i++) {
        let val = this.inputArr[i];
        if (val.name_en) {
          str.push(val.name_en + "[" + val.email + "]");
          queryVal.push(val.email);
        }
      }
      this.inputVal = str.toString();
      this.queryVal = queryVal.toString();
      this.$emit("setinputVal", str, queryVal);
    },
    // 复选框点击事件
    getNode(val) {
      if (this.multiple) {
        this.inputArr = this.$refs.tree.getCheckedNodes();
        this.setinputVal();
      } else {
        this.inputArr = [];
        this.$refs.tree.setCheckedNodes([]);
        this.inputArr.push(val);
        this.setinputVal();
        this.$refs.tree.setCheckedNodes(this.inputArr);
      }
    },
    // 输入框不可输入方法
    focusEvent() {
      this.$refs.ipt.blur();
    },
    // 输入框清空事件
    clearInput() {
      this.queryVal = "";
      this.inputVal = "";
      this.$refs.tree.setCheckedNodes([]);
      this.$emit("setinputVal", [], []);
    },
    // 自定义节点渲染
    renderContent(h, { node, data, store }) {
      // console.log(h, { node, data, store });
      let classArr = [];
      if (data.resign) {
        classArr.push("poh-resign");
      }
      if (!data.enable) {
        classArr.push("poh-tree-root-node");
      }
      let customClass = classArr.join(" ");
      return (
        <span class={customClass}>
          <span>{node.label}</span>
        </span>);
    }
  },
};
</script>

<style>
.poh-resign {
  background-color: #6f6a6a50;
}
.poh-tree-root-node {

}
</style>
<style scoped>
div
  /deep/
  .el-tree
  > .el-tree-node
  > .el-tree-node__content:first-child
  .el-checkbox {
  display: none !important;
}
div
  /deep/
  .el-tree
  > .el-tree-node
  .el-checkbox {
  margin-bottom: 0;
}
.hello {
  position: relative;
}
.tree {
  position: absolute;
  width: 100%;
  margin-top: 6px;
}
.el-popover {
  height: 200px;
  overflow: auto;
}
.tree-box {
  max-height: 300px;
  overflow-y: auto;
}
/*滚动条样式*/
.el-tree::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}

.el-tree::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.el-tree::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/d1/organizationTree.vue